
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { routerNames } from '@/common/js/const';
import { setToken, getToken } from '@/common/js/common';
import feedback from '@/assets/feedback.svg'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Box from 'vux/src/components/box/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Countdown from 'vux/src/components/countdown/index.vue'

import { getUrlKey } from "@/common/js/common";

export default {
name: routerNames.OrderInvoiceSuccess,
components: {
Group,
Cell,
CellBox,
XHeader,
Icon,
Box,
XButton,
Countdown,
},
data() {
return {
br: '',
qrcode: '',
orderId: '',
orderNo: '',
show: true,
time: 5,
value: '',
showCapitaland: false,
showQrcode: false,
feedback
};
},
created() {},
activated() {
var $self = this;

$self.merchant = getUrlKey(window.location.href, "br");
$self.orderId = getUrlKey(window.location.href, "orderId") || $self.$route.query.orderId;
$self.orderNo = getUrlKey(window.location.href, "orderNo") || $self.$route.query.orderNo;
$self.br = $self.$route.query.br;

if ($self.br == 'capitaland') {
$self.showCapitaland = true;
}
if ($self.br == 'Nike') {
$self.showQrcode = true; 
$self.qrcode = '/xforce/static/merch/' + $self.br + '/QR-EINVOICE.png';
}
},
/**计算属性 将状态表中的数据 映射出来*/
computed: {
...mapState({cmsUrl:state=>state.common.cmsUrl})
},
/**初始化的时候调用  类似于 ready */
mounted() {},
methods: {
finish(index) {
console.log(index);
var $self = this;
if (!$self.showCapitaland || !$self.show) {
return;
}
$self.show = false;
$self.value = 'completed';
window.location.href = 'https://mall.capitaland.com.cn/';
},

checkInvoice() {
var $self = this;
var orderId = $self.orderId;
var orderNo = $self.orderNo;
var merchant = $self.merchant;
if (!orderId) {
$self.$vux.alert.show({
title: this.$t('提示'),
content: this.$t('未找到订单信息'),
onShow() {},
onHide() {},
});
return;
}
$self.$webapi.getInvoiceByOrderId(orderId, orderNo, merchant).then(orderRes => {
$self.$clog(orderRes.data);
$self.show = false;
if (orderRes.data.status == 1) {

if (orderRes.data.result instanceof Array) {
var buyerName = orderRes.data.result[0].buyerName;
var price = orderRes.data.result[0].price;
$self.$router.replace({
path: '/orderinvoice/state',
query: {
status: 1,
ids: orderRes.data.result.map(function(item) {
return item.invoiceNo + "_" + item.invoiceCode;
}).join(','),
buyer: buyerName,
price,
orderId,
orderNo,
invoiceTypes: orderRes.data.result.map(function(item) {
return `${item.invoiceType}&${item.invoiceNo}_${item.invoiceCode}`
}).join(','),
},
});
}
} else if (orderRes.data.status == 2) {

$self.$router.replace({
path: '/orderinvoice/state',
query: {
status: 2,orderId, orderNo
},
});
} else if (orderRes.data.status == 0) {

var buyerName = orderRes.data.result[0].buyerName;
var price = orderRes.data.result[0].price;
$self.$router.replace({
path: '/orderinvoice/state',
query: {
status: 0,
buyer: buyerName,
price,orderId, orderNo
},
});
} else {

$self.$vux.alert.show({
title: this.$t('提示'),
content: this.$t('开票失败'),
onShow() {},
onHide() {},
});
}
});
},
},
};
